enum Axis {
  Date,
  Category,
  Value,
  Duration,
}

export default Axis;
